
export const navLinks = [
  {
    id: "hero",
    title: "Startseite",
    link: "/",
    ariaLabel: "Zur Startseite von Angelfreunde 1866 e.V.",
  },
  {
    id: "calendar",
    title: "Veranstaltungsplan",
    link: "/veranstaltungsplan",
    ariaLabel: "Veranstaltungsplan und Termine des Vereins anzeigen",
  },
  {
    id: "membership",
    title: "Mitgliedschaft",
    link: "/mitgliedschaft",
    ariaLabel: "Informationen zur Mitgliedschaft im Verein",
  },
  {
    id: "vorstand",
    title: "Vorstand",
    link: "/vorstand",
    ariaLabel: "Vorstand des Vereins kennenlernen",
  },
  {
    id: "vereinschronik",
    title: "Vereinsgeschichte",
    link: "/vereinsgeschichte",
    ariaLabel: "Geschichte des Vereins entdecken",
  },
  // Beispiel für ein Dropdown-Menü mit SubLinks (optional, auskommentiert)
  /*
  {
    id: "verein",
    title: "Über uns",
    link: null,
    ariaLabel: "Mehr über den Verein erfahren",
    subLinks: [
      {
        id: "vorstand",
        title: "Vorstand",
        link: "/vorstand",
        icon: <FaUsers />,
        ariaLabel: "Vorstand des Vereins",
      },
      {
        id: "vereinschronik",
        title: "Vereinsgeschichte",
        link: "/vereinsgeschichte",
        icon: <FaCalendarAlt />,
        ariaLabel: "Vereinsgeschichte",
      },
      {
        id: "gallery",
        title: "Fotogalerie",
        link: "/fotogalerie",
        icon: <FaImage />,
        ariaLabel: "Fotogalerie des Vereins",
      },
    ],
  },
  */
  {
    id: "contact",
    title: "Kontakt",
    link: "/kontakt",
    ariaLabel: "Kontakt zum Verein aufnehmen",
  },
];